import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { selectCurrentPromptType } from 'services/store/ai/selectors';
import { PromptType } from 'services/store/ai/types';
import { PromptTypeToggleButton, StyledContainer } from './styled';

const PromptTypeToggle = () => {
  const { t } = useTranslation();

  const promptType = useSelector(selectCurrentPromptType);

  return (
    <StyledContainer>
      <Link
        component={RouterLink}
        to={{
          pathname: locations.general.aiMusicGenerator.pathname,
        }}
        sx={{ width: '100%' }}
      >
        <PromptTypeToggleButton
          value={PromptType.AdvancedFormula}
          selected={promptType === PromptType.AdvancedFormula}
        >
          {t('aiMusicGenerator:promptType:generator')}
        </PromptTypeToggleButton>
      </Link>
      <Link
        component={RouterLink}
        to={{
          pathname: locations.general.aiMusicGenerator.pathname,
          hash: PromptType.TextToMusic,
        }}
        sx={{ width: '100%' }}
      >
        <PromptTypeToggleButton
          value={PromptType.TextToMusic}
          selected={promptType === PromptType.TextToMusic}
        >
          {t('aiMusicGenerator:promptType:textToMusic')}
        </PromptTypeToggleButton>
      </Link>
    </StyledContainer>
  );
};

export default PromptTypeToggle;
